import config from "@/config";
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { soddApi } from "../api/soddApi";
import authReducer from "./global/authSlice";
import settingsReducer from "./global/settingsSlice";

export const store = configureStore({
    reducer: {
        settings: settingsReducer,
        auth: authReducer,
        [soddApi.reducerPath]: soddApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(soddApi.middleware), // splite api.
    devTools: config.APP_ENV != "production", // default is true,
});

setupListeners(store.dispatch);
